/* Delivery promise for Meubel31. Shared by the product page, sticky bar and cart drawer, and unit tested. */
(function (root) {
  var DAY = 86400000;
  var fmtDay = new Intl.DateTimeFormat('nl-NL', { weekday: 'long', day: 'numeric' });
  var fmtFull = new Intl.DateTimeFormat('nl-NL', { weekday: 'long', day: 'numeric', month: 'long' });
  var fmtMonth = new Intl.DateTimeFormat('nl-NL', { month: 'long' });

  // Same rules as the live theme: "a/b" is a window in days with a weekend shift, "dd-mm-yyyy" is a fixed date.
  function deliveryText(windowValue, now) {
    now = now || new Date();
    // The theme stores fixed dates on variants as "delivery_dd-mm-yyyy"
    var value = String(windowValue || '').trim().replace(/^delivery_/, '');
    var fixed = value.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
    if (fixed) {
      return 'Verwachte levering ' + fmtFull.format(new Date(Number(fixed[3]), Number(fixed[2]) - 1, Number(fixed[1])));
    }
    var days = value.split('/').map(Number);
    if (days.length !== 2 || days.some(isNaN)) return null;
    var start = new Date(now.getTime() + days[0] * DAY);
    var end = new Date(now.getTime() + days[1] * DAY);
    if (start.getDay() === 6) { start.setDate(start.getDate() + 2); end.setDate(end.getDate() + 2); }
    else if (start.getDay() === 0) { start.setDate(start.getDate() + 1); end.setDate(end.getDate() + 1); }
    if (end.getDay() === 0) end.setDate(end.getDate() + 1);
    if (start.toDateString() === end.toDateString()) return 'Verwachte levering ' + fmtFull.format(start);
    if (start.getMonth() === end.getMonth()) {
      return 'Verwachte levering ' + fmtDay.format(start) + ' of ' + fmtDay.format(end) + ' ' + fmtMonth.format(end);
    }
    return 'Verwachte levering ' + fmtFull.format(start) + ' of ' + fmtFull.format(end);
  }

  root.M31Delivery = { deliveryText: deliveryText };
  if (typeof module === 'object' && module.exports) module.exports = root.M31Delivery;
})(typeof window !== 'undefined' ? window : globalThis);
